// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-mypage-favorite-items[data-v-3879061d]{margin-top:12px}.p-mypage-favorite-items__caption[data-v-3879061d]{color:#191919;font-size:24px;padding:30px 0 18px;text-align:center}.p-mypage-favorite-items__caption small[data-v-3879061d]{color:#191919;font-size:18px}.p-return-to-mypage-top[data-v-3879061d]{align-items:center;background-color:#777;border-radius:4px;color:#fff;display:flex;font-size:18px;height:40px;justify-content:center;margin:auto;width:346px}", ""]);
// Exports
module.exports = exports;
